export default __webpack_public_path__ + "static/media/discord.96c753d5.svg";